/**
 * Проверяет, находимся ли мы в продакшн среде
 * @returns true если это продакшн (клиентская среда + origin https://algocode.io/)
 */
export const isProduction = (): boolean => {
	if (typeof window === 'undefined') {
		return false;
	}

	// Проверяем origin
	const origin = window.location.origin;
	return origin === 'https://algocode.io';
};
